import React from 'react';

import PropTypes from 'prop-types';

import { Category, CategoryIconLess, CategoryIconMore, CategoryBadge, ListItemText } from './style';

export function SidebarCategory({ name, icon, classes, isOpen, isCollapsable, badge, ...rest }) {
  const renderCategoryIcon = () => {
    if (!isCollapsable) {
      return null;
    }
    return isOpen ? <CategoryIconMore /> : <CategoryIconLess />;
  };

  return (
    <Category {...rest}>
      {icon}
      <ListItemText>{name}</ListItemText>
      {renderCategoryIcon()}
      {badge ? <CategoryBadge label={badge} /> : ''}
    </Category>
  );
}

SidebarCategory.propTypes = {
  name: PropTypes.string.isRequired,
  icon: PropTypes.node.isRequired,
  isCollapsable: PropTypes.bool.isRequired,
  isOpen: PropTypes.bool,
  badge: PropTypes.string,
  classes: PropTypes.string,
};

SidebarCategory.defaultProps = {
  badge: '',
  classes: '',
  isOpen: false,
};
